var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF7090A4-69F0-4796-B84B-C265CDF1651C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---My-identity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Identity-Header",
    transform: "translate(-1199.000000, -23.000000)",
    fill: "#959598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1199.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1.08695652 C6.20652174,1.08695652 1.08695652,6.20652174 1.08695652,12.5 C1.08695652,18.7934783 6.20652174,23.9130435 12.5,23.9130435 C18.7934783,23.9130435 23.9130435,18.7934783 23.9130435,12.5 C23.9130435,6.20652174 18.7934783,1.08695652 12.5,1.08695652 M12.5,25 C5.6076087,25 0,19.3923913 0,12.5 C0,5.6076087 5.6076087,0 12.5,0 C19.3923913,0 25,5.6076087 25,12.5 C25,19.3923913 19.3923913,25 12.5,25",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9791667,17.1864583 C11.8354167,17.1864583 11.71875,17.303125 11.71875,17.446875 C11.71875,17.7333333 12.2395833,17.7333333 12.2395833,17.446875 C12.2395833,17.303125 12.1229167,17.1864583 11.9791667,17.1864583 M11.9791667,18.228125 C11.5489583,18.228125 11.1979167,17.878125 11.1979167,17.446875 C11.1979167,17.015625 11.5489583,16.665625 11.9791667,16.665625 C12.409375,16.665625 12.7604167,17.015625 12.7604167,17.446875 C12.7604167,17.878125 12.409375,18.228125 11.9791667,18.228125",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9791667,15.6239583 C11.6916667,15.6239583 11.4583333,15.390625 11.4583333,15.103125 L11.4583333,14.6739583 C11.4583333,13.6385417 12.071875,12.7010417 13.0208333,12.2875 C13.9697917,11.8729167 14.5833333,10.9364583 14.5833333,9.90104167 C14.5833333,8.46458333 13.415625,7.296875 11.9791667,7.296875 L11.978125,7.296875 C11.2833333,7.296875 10.6291667,7.56770833 10.1375,8.059375 C9.64583333,8.55104167 9.375,9.20416667 9.375,9.9 C9.375,10.1885417 9.14166667,10.4208333 8.85416667,10.4208333 C8.56666667,10.4208333 8.33333333,10.1885417 8.33333333,9.9 C8.33333333,8.92604167 8.7125,8.01041667 9.40104167,7.321875 C10.090625,6.634375 11.0041667,6.25520833 11.978125,6.25520833 L11.9791667,6.25520833 C13.9895833,6.25520833 15.625,7.890625 15.625,9.90104167 C15.625,11.35 14.7666667,12.6625 13.4375,13.2416667 C12.86875,13.490625 12.5,14.053125 12.5,14.6739583 L12.5,15.103125 C12.5,15.390625 12.2666667,15.6239583 11.9791667,15.6239583",
    id: "Fill-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.9285bd95d22d0d90892fe4fab18429a9.svg";
export { ForwardRef as ReactComponent };